import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';

import { PageMetaContext } from '../../context';
import { useBasePageQuery, useFlags, useNotNullableContext } from '../../hooks';
import { filterByTypename } from '../../utils/graphql';
import PageSummary from '../PageSummary/PageSummary';
import FacebookShare from '../SocialButtons/FacebookShare';

type TeamSummaryProps = {
  showSummary: boolean;
};

const TeamSummary: FunctionComponent<TeamSummaryProps> = ({ showSummary }) => {
  const basePageData = useBasePageQuery();
  const { enableDonateToTeam } = useFlags();
  const { currentUrl } = useNotNullableContext(PageMetaContext);

  if (!basePageData.data?.page) {
    return null;
  }

  const { relationships, title } = basePageData.data.page;
  const beneficiaries = relationships?.beneficiaries;
  if (!beneficiaries) {
    return null;
  }
  const charities = filterByTypename(beneficiaries.nodes, 'Charity');
  if (showSummary && beneficiaries.totalCount >= 1) {
    return (
      <PageSummary
        pagetitle={title}
        pagesubtitle={
          <Trans i18nKey="team.fundraisingFor" count={beneficiaries.totalCount}>
            Team fundraising for{' '}
            <span className="jg-text--regular">
              {{ charityName: charities[0].name }}
            </span>
          </Trans>
        }
        ctas={
          enableDonateToTeam ? (
            <div className="row row--no-gutter">
              <div className="col-sm-6 jg-space-prxs">
                <a
                  href={`${currentUrl}/donate`}
                  className="jg-btn"
                  data-qa="team-donate"
                >
                  Donate
                </a>
              </div>
              <div className="col-sm-6 jg-space-plxs">
                <FacebookShare showPrefix />
              </div>
            </div>
          ) : (
            <FacebookShare showPrefix />
          )
        }
      />
    );
  }
  return null;
};

export default TeamSummary;
